import React from 'react'
import { ConfirmationDialog } from 'uiComponents/popups/confirmationDialog'
import { useTranslation } from 'translations'

interface DialogProps {
    onDismiss: () => void
}

export function DifferentPricingTypesDialog(props: DialogProps) {
    const { t } = useTranslation()
    return (
        <ConfirmationDialog
            title={t('products.bulkEditDialogs.differentPricingTypes.title')}
            text={t('products.bulkEditDialogs.differentPricingTypes.text')}
            buttonText={t('common.close')}
            destructive
            onConfirm={props.onDismiss}
        />
    )
}
